module.exports = __webpack_public_path__ + "img/science_screenshot_1.90f47777.jpg";